import Backbone from 'backbone';

import { withUiBlock } from '@bingads-webui/uiblocker';

import ContinueImportTemplate from './continue-import-template.pug';
import { getImportStepTitles } from './import-step-titles';

export class ContinueImportView extends Backbone.View {
  initialize({ deps, options }) {
    this.deps = deps;
    this.i18n = deps.i18n;
    this.repo = deps.repository;
    this.permissions = deps.config.get('Permissions') || {};
    this.isAdGroupLevelImportEnabled = !deps.uxMode === 'signup';
    this.importType = options.importType;
    this.importId = options.importId;
    this.steps = getImportStepTitles(
      this.importType, options.importNotSubmitted,
      this.isAdGroupLevelImportEnabled
    );
  }

  events() {
    return {
      'click .continueImport': 'continueImport',
      'click .cancelImport': 'cancelImport',
    };
  }

  logTrace(msg) {
    this.repo.logTrace(msg, this.deps.logActivities.loadContinueImport);
  }

  render() {
    let pageTitle = this.i18n.get('FileImport_PageTitle');
    if (this.isGoogleImport()) {
      pageTitle = this.i18n.get('GoogleImport_PageTitle');
    } else if (this.isFacebookImport()) {
      pageTitle = this.i18n.get('FacebookImport_PageTitle');
    }

    this.$el.html(ContinueImportTemplate({
      i18n: this.i18n,
      steps: this.steps,
      pageTitle,
    }));

    this.logTrace(`render continue import with importType=${this.importType}`);
    return this;
  }

  isGoogleImport() {
    return this.importType === 'GoogleAPIImport';
  }

  isFacebookImport() {
    return this.importType === 'FacebookImport';
  }

  continueImport() {
    this.logTrace('click continue in continue import');
    if (this.isGoogleImport()) {
      this.repo.redirectToInProgressGoogleImport(this.importId);
    } else if (this.isFacebookImport()) {
      this.repo.redirectToInProgressFacebookImport(this.importId);
    } else {
      this.repo.redirectToInProgressFileImport(this.importId);
    }
  }

  cancelImport() {
    this.logTrace('click cancel in continue import');
    return this.repo.cancelCurrentImportAndRedirectToCampaigns(this.importId)
      .catch((err) => {
        this.repo.logException(err);
        this.deps.alertCenter.showError(this.repo.getLocalizedErrorMessage());
      })
      .finally(withUiBlock());
  }
}
